import './ReviewsList.styles.scss';

import PropTypes from 'prop-types';

import ReviewsItem from './ReviewsItem/ReviewsItem';

const ReviewsList = ({ reviewsArray, setRef }) => {
    return (
        <ul className="reviews__list grid justify-space">
            {reviewsArray.map((item, index) => (
                <ReviewsItem
                    key={index}
                    avatar={item.avatar}
                    name={item.name}
                    rating={item.rating}
                    text={item.text}
                    username={item.username}
                    setRef={setRef}
                />
            ))}
        </ul>
    );
};

ReviewsList.propTypes = {
    reviewsArray: PropTypes.array.isRequired,
    setRef: PropTypes.func,
};

export default ReviewsList;
